import { useContext, useEffect, useState } from 'react';
import { TimerContext } from '../context/TimerContext';
import { formatMillisecondsToTime } from '../../../utils/formatTime';

function RunningTaskTime({ open = true }) {
  const { startTime, isRunning } = useContext(TimerContext);
  const [taskTimer, setTaskTimer] = useState(null);
  useEffect(() => {
    let intervalFn;
    if (isRunning) {
      intervalFn = setInterval(() => {
        const diff = Date.now() - new Date(startTime);
        setTaskTimer(formatMillisecondsToTime(diff));
      }, 1000);
    } else {
      clearInterval(intervalFn);
    }

    return () => {
      clearInterval(intervalFn);
    };
  }, [isRunning, startTime]);

  if (!open) return '';

  return taskTimer ?? '00:00:00';
}

export default RunningTaskTime;
